
class StickyQuickView extends HTMLElement {
    constructor() {
        super();
		this.sticky = this;
        this.stickyBounds = document.getElementById('product-add-to-cart');
    }

    connectedCallback(){
        this.onScrollHandler = this.onScroll.bind(this);
		window.addEventListener('scroll', this.onScrollHandler, false);

        const height = this.closest('[data-sticky-quick-view]').clientHeight;
    }

    onScroll() {
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
		const offsetScroll = $(this.stickyBounds).offset().top + $(this.stickyBounds).outerHeight(true) + 100;

        var windowWidth = window.innerWidth;

		if (scrollTop > offsetScroll) {
			requestAnimationFrame(this.showSticky.bind(this));
			var height = document.querySelector('sticky-header').offsetHeight || document.querySelector('sticky-header-mobile').offsetHeight;

			this.style.top = `${height}px`;
		} else{
			requestAnimationFrame(this.hideSticky.bind(this));
		}

        this.currentScrollTop = scrollTop;
    }

    hideSticky() {
        this.classList.remove('show-sticky', 'animate');
    }

    showSticky() {
        this.classList.add('show-sticky', 'animate');
    }
}

customElements.define('sticky-quick-view', StickyQuickView);
